import { render, staticRenderFns } from "./HeroMap.vue?vue&type=template&id=6bc12769&scoped=true"
import script from "./HeroMap.vue?vue&type=script&lang=js"
export * from "./HeroMap.vue?vue&type=script&lang=js"
import style0 from "./HeroMap.vue?vue&type=style&index=0&id=6bc12769&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc12769",
  null
  
)

export default component.exports